import { safeLocalStorage } from '@ifixit/utils';

/** "Not mine" hides the prompt for that device on that surface for this long. */
export const NOT_MINE_HIDE_DAYS = 30;

const STORAGE_KEY = 'workbench-prompt-not-mine';
const DAY_MS = 24 * 60 * 60 * 1000;

/** `${source}:${wikiid}` to the time "Not mine" was tapped. */
type HiddenPrompts = Record<string, number>;

function promptKey(source: string, wikiid: number): string {
   return `${source}:${wikiid}`;
}

function isHidden(hidden: HiddenPrompts, key: string, now: number): boolean {
   const hiddenAt = hidden[key];
   return hiddenAt !== undefined && now - hiddenAt < NOT_MINE_HIDE_DAYS * DAY_MS;
}

/** Drops expired entries on the way, so the record never grows past what is still hidden. */
function recordNotMine(hidden: HiddenPrompts, key: string, now: number): HiddenPrompts {
   const stillHidden = Object.fromEntries(
      Object.entries(hidden).filter(([entryKey]) => isHidden(hidden, entryKey, now))
   );
   return { ...stillHidden, [key]: now };
}

function read(): HiddenPrompts {
   try {
      return safeLocalStorage.getJson<HiddenPrompts>(STORAGE_KEY) ?? {};
   } catch {
      return {};
   }
}

export function isPromptHidden(source: string, wikiid: number, now = Date.now()): boolean {
   return isHidden(read(), promptKey(source, wikiid), now);
}

export function hidePrompt(source: string, wikiid: number, now = Date.now()): void {
   try {
      safeLocalStorage.setJson(STORAGE_KEY, recordNotMine(read(), promptKey(source, wikiid), now));
   } catch {
      return;
   }
}
